import React from 'react'
import './footer.css'
import logo from '../../resources/images/logo.png'
import { Link } from 'react-router-dom'

function Footer() {
  const usefulLinks = [
    { to: '/about-us',       label: 'About Us' },
    { to: '/contact',        label: 'Contact Us' },
    { to: '/testimonials',   label: 'Testimonials' },
    { to: '/privacy-policy', label: 'Privacy Policy' },
  ]

  return (
    <footer className="ft-footer">

      {/* ── Main grid ──────────────────────────────────────── */}
      <div className="ft-main">

        {/* Brand */}
        <div className="ft-brand">
          <Link to="/" className="ft-brand__logo">
            <img src={logo} alt="JFE Bank" />
          </Link>
          <p className="ft-brand__desc">
            Managing your finances is a lifelong journey with many milestones and
            obstacles along the way. Whether you're just starting out, in your prime
            working years, or preparing for retirement, having a sound financial plan
            is crucial for achieving your goals.
          </p>
          <a className="ft-brand__email" href="mailto:info@nextwavesfinsedge.com">
            <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
              <polyline points="22,6 12,13 2,6"/>
            </svg>
            info@nextwavesfinsedge.com
          </a>
        </div>

        {/* Useful links */}
        <div className="ft-col">
          <p className="ft-col__heading">Useful Links</p>
          <ul className="ft-col__list">
            {usefulLinks.map(({ to, label }) => (
              <li key={to}>
                <Link to={to}>{label}</Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div className="ft-col">
          <p className="ft-col__heading">Contact</p>
          <ul className="ft-col__list">
            <li><span>info@nextwavesfinsedge.com</span></li>
            <li><span>Response within one business day</span></li>
          </ul>
        </div>

      </div>

      {/* ── Divider ────────────────────────────────────────── */}
      <div className="ft-divider"><hr /></div>

      {/* ── Copyright bar ──────────────────────────────────── */}
      <div className="ft-copyright">
        <p className="ft-copyright__text">
          Copyright © 2025 by <strong>{process.env.REACT_APP_APP_NAME}</strong>. All Rights Reserved.
        </p>
        <div className="ft-copyright__links">
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/contact">Contact</Link>
        </div>
      </div>

    </footer>
  )
}

export default Footer